import { Box } from '@mui/material';
import React from 'react';
import styles from './index.module.scss';

type Props = {
  placeholder: string;
  setStoredText?: (text: string) => void;
};

export default function PersonalizedTextArea({
  placeholder,
  setStoredText,
}: Props) {
  return (
    <Box className={styles.textAreaWrapper}>
      <textarea
        rows={6}
        className={styles.textArea}
        placeholder={placeholder}
        onChange={(event) => {
          if (setStoredText) {
            setStoredText(event.target.value);
          }
        }}
      ></textarea>
    </Box>
  );
}
